import XAPPService from 'app/Core/services/XAPPService';
export const GET_CID = '[CID APP] GET CID';
export const CID_WARNING = '[CID APP] CID WARNING';
export const CID_INFO = '[CID APP] CID INFO';
export const ERROR_CID = '[CID APP] CID ERROR';

export function list(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappLookupActionFactory("CID", AActions, AConditionsAND, AConditionsOR)

        XAPPService.XappLookupAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_CID,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data) : "",
                    })
                ])
            );
    };
}

